
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if(data){ 
    ; __append("\n\n    <div class=\"support-bar\">\n        <div class=\"bar-total\">\n            <span class=\"bar-progress\"></span>\n\n        </div>\n        ")
    ;  if(data.ad){ 
    ; __append("\n        <div class=\"ad\">\n            <img src=\"")
    ; __append(escape(data.ad))
    ; __append("\">\n        </div>\n        ")
    ;  } 
    ; __append("\n\n    </div>\n    <div class=\"support-actions\" data-sid=\"")
    ; __append(escape(data.sid))
    ; __append("\">\n        <div class=\"ht actions\">\n            <span class=\"ht-support\"></span>\n            <span class=\"ht-support-name\">")
    ;  if(data.show == 1){ 
    ; __append("主队<span style=\"margin: 0 5px;\">—</span>")
    ;  } 
    ; __append("<span class=\"support-num\">0</span></span>\n        </div>\n        <div class=\"vt actions\">\n            <span class=\"vt-support-name\"><span class=\"support-num\">0</span>")
    ;  if(data.show == 1){ 
    ; __append("<span style=\"margin: 0 5px;\">—</span>客队")
    ;  } 
    ; __append("</span>\n            <span class=\"vt-support\"></span>\n        </div>\n    </div>\n")
    ;  } 
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/modules/sportMatch/support.ejs
// module id = 667
// module chunks = 0